export const MainVisual = () => {
  const url = new URL(window.location.href);
  const params = url.searchParams;

  let selectedProduct = '51';
  selectedProduct = params.get('product') as string;

  let brand = 'xiv';
  let title = 'エクシブ';

  switch (selectedProduct) {
    case '51':
      brand = 'xiv';
      title = 'エクシブ';
      break;
    case '81':
      brand = 'xiv';
      title = 'エクシブ';
      break;
    case '65':
      brand = 'xiv';
      title = 'エクシブ';
      break;
    case '85':
      brand = 'xiv';
      title = 'エクシブ';
      break;
    case '86':
      brand = 'xiv';
      title = 'エクシブ';
      break;
    case '71':
      brand = 'baycourt';
      title = 'ベイコート倶楽部';
      break;
    case '75':
      brand = 'baycourt';
      title = 'ベイコート倶楽部';
      break;
    case '72':
      brand = 'baycourt';
      title = 'ベイコート倶楽部';
      break;
    case '76':
      brand = 'baycourt';
      title = 'ベイコート倶楽部';
      break;
    case '91':
      brand = 'sanctuarycourt';
      title = 'サンクチュアリコート';
      break;
    case '92':
      brand = 'sanctuarycourt';
      title = 'サンクチュアリコート';
      break;
    case '93':
      brand = 'sanctuarycourt';
      title = 'サンクチュアリコート';
      break;
    case '94':
      brand = 'sanctuarycourt';
      title = 'サンクチュアリコート';
      break;
  }

  return (
    <div className={`un-mv un-mv-${brand}`}>
      <div className='flex h-[146px] items-center justify-start px-[15px] md:mx-auto md:h-full md:max-w-[1160px]'>
        <picture className='mt-[-23px] ml-[3px] md:mt-[-45px] md:ml-[32px]'>
          <source srcSet={`./img/logo_${brand}_l.svg`} media='(min-width: 768px)' />
          <img src={`./img/logo_${brand}_s.svg`} alt={title} className='inline-block' />
        </picture>
      </div>
    </div>
  );
};
